import b from 'b_';
import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
// TODO: EDUCATION-11293 ts fix
// @ts-ignore
import Popup from '../popup/popup';
import { TOOLTIP_THEME } from '../tooltip/constants';
import Tooltip from '../tooltip/tooltip';

import IconHelp from './__icon/help__icon';
import { HELP_THEME, HELP_SIZE, HELP_TYPE, HELP_ACTION } from './help.constants';

import './help.scss';

interface Props {
    children?: React.ReactElement;
    mix?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    popupProps?: Record<string, any>;
    size?: HELP_SIZE;
    theme?: HELP_THEME;
    tooltipMix?: string;
    tooltipTheme?: TOOLTIP_THEME;
    type?: HELP_TYPE;
    showPopupOnAction?: HELP_ACTION;
}

class Help extends React.PureComponent<Props> {
    static defaultProps = {
        size: HELP_SIZE.SMALL,
        theme: HELP_THEME.SIMPLE,
        type: HELP_TYPE.QUESTION,
        showPopupOnAction: HELP_ACTION.CLICK,
    };

    static propTypes = {
        theme: PropTypes.oneOf(Object.values(HELP_THEME)),
        type: PropTypes.oneOf(Object.values(HELP_TYPE)),
        size: PropTypes.oneOf(Object.values(HELP_SIZE)),
        tooltipTheme: PropTypes.oneOf(Object.values(TOOLTIP_THEME)),
    };

    componentDidMount() {
        this.popupRef.setOwner(this.iconWrapperRef);
    }

    popupRef: Popup;
    iconWrapperRef?: HTMLDivElement;

    onIconWrapperRef = (ref: HTMLDivElement) => {
        this.iconWrapperRef = ref;
    };

    onPopupRef = (ref: Popup) => {
        this.popupRef = ref;
    };

    togglePopup = () => {
        this.popupRef.toggle();
    };

    hidePopup = () => {
        this.popupRef.hide();
    };

    showPopup = () => {
        this.popupRef.show();
    };

    getPopupToggleEventHandlers() {
        const { showPopupOnAction } = this.props;

        switch (showPopupOnAction) {
            case HELP_ACTION.CLICK:
                return {
                    onClick: this.togglePopup,
                };
            case HELP_ACTION.HOVER:
                return {
                    onMouseEnter: this.showPopup,
                    onMouseLeave: this.hidePopup,
                };
            default:
                return {
                    onClick: this.togglePopup,
                };
        }
    }

    render() {
        const { mix, popupProps, size, theme, tooltipMix, tooltipTheme, type } = this.props;
        const popupToggleEventHandlers = this.getPopupToggleEventHandlers();

        return (
            <div
                className={cx(
                    b('help', {
                        size,
                        theme,
                    }),
                    mix
                )}
            >
                <div
                    {...popupToggleEventHandlers}
                    className={b('help', 'icon-wrapper', { type })}
                    ref={this.onIconWrapperRef}
                >
                    <IconHelp helpType={type} />
                </div>
                <Tooltip mix={tooltipMix} onPopupRef={this.onPopupRef} popupProps={popupProps} theme={tooltipTheme}>
                    {this.props.children}
                </Tooltip>
            </div>
        );
    }
}

export default Help;
